import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { TimespanRecord } from "../../model/data/TimespanRecord";

export const DateTickIntervalRecord = Record({
  majorSpan: TimespanRecord(),
  majorFormat: null,
  minorSpan: TimespanRecord(),
  minorFormat: null
});

const data = {
  objects: {
    majorSpan: "TimespanRecord",
    minorSpan: "TimespanRecord"
  }
};
createFromJS.registerCallback(
  "DateTickIntervalRecord",
  createFromJS.createNestedCallback(DateTickIntervalRecord, data)
);
